import { render } from "./XgPlayer2.vue?vue&type=template&id=1e4ed2bc&scoped=true"
import script from "./XgPlayer2.vue?vue&type=script&lang=js"
export * from "./XgPlayer2.vue?vue&type=script&lang=js"

import "./XgPlayer2.vue?vue&type=style&index=0&id=1e4ed2bc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4ed2bc"]])

export default __exports__